import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';

// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/workspace.json)
// Used for NEW navigation
const workspaceIconData = {
	icon: {
		attrs: [{}, {}, {}, {}],
		grid: 0,
		isMulticolor: false,
		isMulticolor2: false,
		paths: [
			'M528.011 377.274c24.418 0 44.211 19.794 44.211 44.21v188.637c-0.006 24.411-19.798 44.21-44.211 44.21s-44.203-19.798-44.21-44.21v-188.637c0-24.416 19.794-44.21 44.21-44.21z',
			'M386.539 471.582c24.416 0 44.21 19.794 44.21 44.211v94.309c0 24.418-19.794 44.211-44.21 44.211-24.418 0-44.211-19.794-44.211-44.211v-94.309c0-24.418 19.794-44.211 44.211-44.211z',
			'M669.485 282.946c24.414 0 44.206 19.797 44.21 44.211v282.946c0 24.418-19.794 44.211-44.21 44.211-24.418 0-44.211-19.794-44.211-44.211v-282.946c0.005-24.414 19.797-44.211 44.211-44.211z',
			'M528.011 0c24.414 0 44.208 19.797 44.211 44.21v50.116h399.067c40.043 0.001 72.494 32.46 72.498 72.499v603.626c-0.005 40.042-32.456 72.498-72.498 72.498h-336.534l89.578 89.578 3.040 3.368c14.15 17.363 13.139 42.984-3.040 59.166-16.184 16.182-41.802 17.181-59.165 3.022l-3.368-3.022-133.789-133.805-133.787 133.805-3.35 3.022c-17.362 14.163-42.978 13.155-59.166-3.022-17.266-17.266-17.266-45.269 0-62.534l89.578-89.578h-336.568c-40.034-0.005-72.494-32.459-72.498-72.498v-603.626c0.004-40.037 32.462-72.493 72.498-72.499h399.085v-50.116c0.003-24.414 19.795-44.21 44.21-44.21zM100.639 754.528h854.727v-571.781h-854.727v571.781z',
		],
		tags: ['workspace'],
		width: 1056,
	},
	attrs: [{}, {}, {}, {}],
	properties: {
		code: 59759,
		id: 4,
		name: 'workspace',
		order: 3430,
		prevSize: 20,
	},
	setIdx: 0,
	setId: 2,
	iconIdx: 9,
};

// Create IconBuilder from cond-ui-kit data
const WorkspaceIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	workspaceIconData as any,
	'#89c32e', // Default green color for new navigation
);

export default WorkspaceIconBuilder;
